export { default } from "ember-stereo/-private/utils/one-at-a-time";
